import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=83ae8466&scoped=true&lang=pug&"
import script from "./InformationDialog.vue?vue&type=script&lang=ts&"
export * from "./InformationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InformationDialog.vue?vue&type=style&index=0&id=83ae8466&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ae8466",
  null
  
)

export default component.exports